<h3>{{ "My Courses" | translate }}</h3>
